 <template>
  <div>
    <el-dialog
      title="รายละเอียดรายการส่งเสริมการขาย"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
    >
      <el-form>
        <table>
          <template v-if="info.deleted_at">
            <tr>
              <th v-bind:style="styleOption">วันที่ลบรายการส่งเสริมการขาย : </th>
              <td v-bind:style="styleOption">{{info.deleted_at}}</td>
            </tr>
            <tr>
              <th v-bind:style="styleOption">ชื่อผู้ลบรายการส่งเสริมการขาย : </th>
              <td v-bind:style="styleOption">{{info.deleted_by}}</td>
            </tr>
          </template>
          <tr>
            <td v-bind:style="styleOption"><b>รายละเอียดทั่วไป</b></td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              รหัสรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_code}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ชื่อรายการส่งเสริมการขาย(ภาษาไทย) :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_name_th}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ชื่อรายการส่งเสริมการขาย(ภาษาอังกฤษ) :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_name_en}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ประเภทบริการของรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_category == 'postpaid' ? 'รายเดือน' : 'เติมเงิน'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ชนิดของรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_type === 'main' ? 'รายการส่งเสริมการขายหลัก':'รายการส่งเสริมการขายเสริม'}}
            </td>
          </tr>
          <tr><td colspan="2"></td></tr>
          <tr>
            <td v-bind:style="styleOption"><b>ระยะเวลา</b></td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              วันเริ่มต้นการเสนอขาย: 
            </td>
            <td v-bind:style="styleOption">
              {{info.start_sale_date || '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              วันสิ้นสุดการเสนอขาย:
            </td>
            <td v-bind:style="styleOption">
              {{info.end_sale_date || '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              วันเริ่มต้นการให้บริการ:
            </td>
            <td v-bind:style="styleOption">
              {{info.start_service_date || '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              วันสิ้นสุดการให้บริการ: <br/>
            </td>
            <td v-bind:style="styleOption">
              {{info.end_service_date || '-'}} <br/>
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_price ? info.promotion_price + ' บาท' : '-'}} 
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2"><b>ค่าบริการจำแนกตามประเภทบริการ</b></td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.voice_service ? info.voice_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.sms_service ? info.sms_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.mms_service ? info.mms_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ Internet :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_service ? info.internet_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              WiFi :
            </td>
            <td v-bind:style="styleOption">
              {{info.wifi_service ? info.wifi_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Others :
            </td>
            <td v-bind:style="styleOption">
              {{info.other_service ? info.other_service + ' บาท' : '-'}}
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2"><b>สิทธิ์การใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ</b></td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.voice_minute ? info.voice_minute + ' นาที' : info.voice_second ? info.voice_second + ' วินาที' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.sms_amount ? info.sms_amount + ' ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.mms_amount ? info.mms_amount + ' ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              บริการอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_MB ? info.internet_MB + ' MB' : info.internet_GB ? info.internet_GB + ' GB' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ความเร็วอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_speed_Kbps ? info.internet_speed_Kbps + ' Kbps' : info.internet_speed_Mbps ? info.internet_speed_Mbps + ' Mbps' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Wifi :
            </td>
            <td v-bind:style="styleOption">
              {{info.wifi_service_th ? info.wifi_service_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              อื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.other_service_th ? info.other_service_th : '-'}}
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2"><b>อัตราค่าบริการเฉลี่ย</b></td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.voice_per_minute ? Math.round(info.voice_per_minute * 100)/100 + ' บาท/นาที' : info.voice_per_second ? info.voice_per_second + ' บาท/วินาที' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.sms_per_message ? info.sms_per_message + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.mms_per_message ? info.mms_per_message + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ค่าบริการอินเทอร์เน็ต :
            </td>
            <td v-bind:style="styleOption">
              {{info.internet_per_MB ? info.internet_per_MB.toFixed(5) + ' บาท/MB' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Wifi :
            </td>
            <td v-bind:style="styleOption">
              {{info.masr_wifi_service ? info.masr_wifi_service : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              อื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.masr_other_service ? info.masr_other_service : '-'}}
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2">
              <b>อัตราค่าบริการต่อหน่วยในส่วนที่เกินกว่าสิทธิการใช้งานของรายการส่งเสริมการขาย (*เฉพาะ Postpaid)</b>
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2">
               <b>อัตราค่าบริการเสียง</b>
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               นาทีใดๆสูงสุด :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_voice_service ? info.average_voice_service + ' บาท/นาที' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               เงื่อนไขอื่นๆ (ภาษาไทย) :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_voice_remark_th ? info.average_voice_remark_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               เงื่อนไขอื่นๆ (ภาษาอังกฤษ) :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_voice_remark_en ? info.average_voice_remark_en : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2">
               <b>อัตราค่าบริการด้านข้อมูล</b>
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               บริการ SMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_sms_service ? info.average_sms_service + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               บริการ MMS :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_mms_service ? info.average_mms_service + ' บาท/ข้อความ' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               บริการ Internet :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_internet_service ? info.average_internet_service + ' บาท/MB' : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               เงื่อนไขอื่นๆ (ภาษาไทย) :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_other_service_th ? info.average_other_service_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               เงื่อนไขอื่นๆ (ภาษาอังกฤษ) :
            </td>
            <td v-bind:style="styleOption">
              {{info.average_other_service_en ? info.average_other_service_en : '-'}}
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption" colspan="2">
              <b>สิทธิพิเศษ</b>
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               ให้บริการความบันเทิง :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_content_th ? info.privilege_content_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               ให้บริการโซเชียลมีเดีย :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_social_th ? info.privilege_social_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               ให้บริการเกม :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_game_th ? info.privilege_game_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               พรีเมียม :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_premium_th ? info.privilege_premium_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               อุปกรณ์อื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_device_th ? info.privilege_device_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
               ให้บริการอื่นๆ :
            </td>
            <td v-bind:style="styleOption">
              {{info.privilege_other_th ? info.privilege_other_th : '-'}}
            </td>
          </tr>
          <tr><td></td></tr>
          <tr>
            <td v-bind:style="styleOption">
              รูปแบบการคิดค่าบริการประเภทเสียง :
            </td>
            <td v-bind:style="styleOption">
              {{info.service_charge_type == 'minute' ? 'นาที' : info.service_charge_type == 'second' ? 'วินาที' : '-' }}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_condition_th ? info.promotion_condition_th : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_link_url ? decodeURI(info.promotion_link_url) : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_ussd ? decodeURI(info.promotion_ussd) : '-'}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              ลิงก์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย :
            </td>
            <td v-bind:style="styleOption">
              {{info.promotion_banner ? decodeURI(info.promotion_banner) : '-'}}
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      labelPosition: "top",
      show: false,
      month: [],
      styleOption: {
        textAlign: 'left',
        width: '50%',
        verticalAlign: 'top',
        wordBreak: 'normal'
      },
      styleCaption: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold'
      }
    };
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["info", "dialog"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
 